(function () {
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .factory('RegionFilter', RegionFilterClass);

  function RegionFilterClass(BaseFilterType, FiltersHelper) {

    function RegionFilter(filterData, stateParams) {
      if (!(this instanceof RegionFilter)) return new RegionFilter(filterData, stateParams);

      BaseFilterType.call(this, filterData, stateParams);
    }

    RegionFilter.prototype = _.create(BaseFilterType.prototype, {
      formatFilterValues: FiltersHelper.formatTreeFilter,
      selectedParams: function (stateParams) {
        return getSelectedParams(stateParams);
      },
      isFilterSelected: function (params) {
        return _.map(params, function (region) {
          return FiltersHelper.includesDefaultFn(region);
        });
      }
    });

    function getSelectedParams(stateParams) {
      return [stateParams.continent, stateParams.country, stateParams.uiLocale];
    }

    return RegionFilter;

  }

})();